import { useState } from "react";
import api from "../axios";
import { UserCircle, Mail, Lock, Save } from "lucide-react";

export default function Profile() {
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [emailSaving, setEmailSaving] = useState(false);
  const [emailMsg, setEmailMsg] = useState("");

  const [passwords, setPasswords] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [pwSaving, setPwSaving] = useState(false);
  const [pwMsg, setPwMsg] = useState("");

  const updateEmail = async (e) => {
    e.preventDefault();
    setEmailMsg("");

    if (!email.trim()) {
      setEmailMsg("Email/Username khaali nahi ho sakta.");
      return;
    }

    setEmailSaving(true);
    try {
      const res = await api.put("/auth/profile", { email });
      setEmailMsg(res.data.msg || "Update ho gaya ✅");
      localStorage.setItem("email", email);
    } catch (err) {
      setEmailMsg(err.response?.data?.msg || "Update failed");
    } finally {
      setEmailSaving(false);
    }
  };

  const updatePassword = async (e) => {
    e.preventDefault();
    setPwMsg("");

    if (!passwords.current_password || !passwords.new_password) {
      setPwMsg("Current aur new password dono bharein.");
      return;
    }

    if (passwords.new_password !== passwords.confirm_password) {
      setPwMsg("Naya password aur confirm password match nahi kar rahe.");
      return;
    }

    setPwSaving(true);
    try {
      const res = await api.put("/auth/change-password", {
        current_password: passwords.current_password,
        new_password: passwords.new_password,
      });
      setPwMsg(res.data.msg || "Password change ho gaya ✅");
      setPasswords({ current_password: "", new_password: "", confirm_password: "" });
    } catch (err) {
      setPwMsg(err.response?.data?.msg || "Password change failed");
    } finally {
      setPwSaving(false);
    }
  };

  return (
    <div className="w-full min-h-full bg-gray-50 px-4 py-6 md:px-8 md:py-8">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
            <UserCircle className="text-purple-600" size={26} />
            My Profile
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Apna login email/username aur password yahan se khud change karein.
          </p>
        </div>

        {/* Email / Username */}
        <form onSubmit={updateEmail} className="bg-white rounded-2xl shadow-sm border p-6 md:p-8 mb-6">
          <h2 className="font-bold text-gray-800 flex items-center gap-2 mb-4">
            <Mail size={18} className="text-purple-600" /> Email / Username
          </h2>

          <label className="text-sm font-semibold text-gray-700">Login Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border border-gray-300 rounded-lg px-3 py-2.5 w-full mt-1.5 focus:ring-2 focus:ring-purple-500 outline-none"
          />

          {emailMsg && (
            <div
              className={`mt-3 text-sm rounded-lg px-3 py-2.5 border ${
                emailMsg.includes("✅")
                  ? "bg-green-50 text-green-700 border-green-200"
                  : "bg-red-50 text-red-600 border-red-200"
              }`}
            >
              {emailMsg}
            </div>
          )}

          <button
            type="submit"
            disabled={emailSaving}
            className="mt-5 inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold px-6 py-2.5 rounded-lg shadow hover:opacity-90 disabled:opacity-50"
          >
            <Save size={16} /> {emailSaving ? "Saving..." : "Update Email"}
          </button>
        </form>

        {/* Password */}
        <form onSubmit={updatePassword} className="bg-white rounded-2xl shadow-sm border p-6 md:p-8">
          <h2 className="font-bold text-gray-800 flex items-center gap-2 mb-4">
            <Lock size={18} className="text-purple-600" /> Change Password
          </h2>

          <div className="space-y-4">
            <div>
              <label className="text-sm font-semibold text-gray-700">Current Password</label>
              <input
                type="password"
                value={passwords.current_password}
                onChange={(e) => setPasswords({ ...passwords, current_password: e.target.value })}
                className="border border-gray-300 rounded-lg px-3 py-2.5 w-full mt-1.5 focus:ring-2 focus:ring-purple-500 outline-none"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-gray-700">New Password</label>
              <input
                type="password"
                value={passwords.new_password}
                onChange={(e) => setPasswords({ ...passwords, new_password: e.target.value })}
                className="border border-gray-300 rounded-lg px-3 py-2.5 w-full mt-1.5 focus:ring-2 focus:ring-purple-500 outline-none"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-gray-700">Confirm New Password</label>
              <input
                type="password"
                value={passwords.confirm_password}
                onChange={(e) => setPasswords({ ...passwords, confirm_password: e.target.value })}
                className="border border-gray-300 rounded-lg px-3 py-2.5 w-full mt-1.5 focus:ring-2 focus:ring-purple-500 outline-none"
              />
            </div>
          </div>

          {pwMsg && (
            <div
              className={`mt-4 text-sm rounded-lg px-3 py-2.5 border ${
                pwMsg.includes("✅")
                  ? "bg-green-50 text-green-700 border-green-200"
                  : "bg-red-50 text-red-600 border-red-200"
              }`}
            >
              {pwMsg}
            </div>
          )}

          <button
            type="submit"
            disabled={pwSaving}
            className="mt-5 inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold px-6 py-2.5 rounded-lg shadow hover:opacity-90 disabled:opacity-50"
          >
            <Save size={16} /> {pwSaving ? "Saving..." : "Change Password"}
          </button>
        </form>
      </div>
    </div>
  );
}